var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogOutSideBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.033,
    height: 18.377,
    viewBox: "0 0 15.033 18.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer_8",
    "data-name": "Layer 8",
    d: "M18.036,3.506V16.871A2.431,2.431,0,0,1,15.7,19.377H9.683a.835.835,0,0,1,0-1.671H15.7a.777.777,0,0,0,.668-.835V3.506a.777.777,0,0,0-.668-.835H9.683A.835.835,0,0,1,9.683,1H15.7A2.431,2.431,0,0,1,18.036,3.506ZM5.849,11.024h7.175a.835.835,0,0,0,0-1.671H5.849L7.035,8.175A.839.839,0,0,0,5.849,6.989L3.243,9.6a.864.864,0,0,0,0,1.186l2.606,2.606A.839.839,0,1,0,7.035,12.2Z",
    transform: "translate(-3.005 -1)",
    fill: "#231f20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutSideBar);
export default __webpack_public_path__ + "static/media/logOutSideBar.0a22227dd2f69c527f3189e255fc0001.svg";
export { ForwardRef as ReactComponent };